import brand from '@helpers/brand';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';
import { buttonTheme, sharedButtonStyles } from '../ButtonShared.styles';
const Button = styled.span `
  ${sharedButtonStyles};

  ${({ themeOption }) => themeOption === 'green' &&
    css `
      ${buttonTheme({
        bgColor: brand.hta.green,
        borderColor: brand.hta.green,
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: brand.hta.greenLight,
        borderColor: brand.hta.greenLight,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'greenOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba(brand.hta.green, 0),
        borderColor: brand.hta.green,
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: brand.hta.greenLight,
        borderColor: brand.hta.green,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'greenAlt' &&
    css `
      ${buttonTheme({
        bgColor: rgba(brand.htaRebrand.green, 0.5),
        borderColor: 'transparent',
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: rgba(brand.htaRebrand.green, 0.5),
        borderColor: 'transparent',
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'aplGreen' &&
    css `
      ${buttonTheme({
        bgColor: brand.apl.green,
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: brand.apl.greenLight,
        borderColor: brand.apl.greenLight,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'aplGreenOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba(brand.apl.green, 0),
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: brand.apl.greenLight,
        borderColor: brand.apl.green,
        fgColor: brand.black,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'white' &&
    css `
      ${buttonTheme({
        bgColor: brand.white,
        borderColor: brand.white,
        fgColor: brand.black,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: '#383838',
        borderColor: brand.white,
        fgColor: brand.white,
    })}
      }
    `}

  ${({ themeOption }) => themeOption === 'whiteOutline' &&
    css `
      ${buttonTheme({
        bgColor: rgba('#383838', 0),
        borderColor: brand.white,
        fgColor: brand.white,
    })}

      a:focus &,
      a:hover &,
      button:focus &,
      button:hover & {
        ${buttonTheme({
        bgColor: '#383838',
        borderColor: brand.white,
        fgColor: brand.white,
    })}
      }
    `}
`;
export default {
    Button,
};
